import React from 'react';
import { buildImageURL } from '../../helpers';

const IMAGES = {
  x60Pro: {
    d: buildImageURL('/buy_now_x60t_pro_plus.png'),
    m: buildImageURL('/buy_now_x60t_pro_plus.png')
  },
  x60: {
    d: buildImageURL('/buy_now_x60_pro_plus.png'),
    m: buildImageURL('/buy_now_x60_pro_plus.png')
  }
};

export default function Phone({ mobile = false }) {
  const x60ProImg = mobile ? IMAGES.x60Pro.m : IMAGES.x60Pro.d;
  const x60Img = mobile ? IMAGES.x60.m : IMAGES.x60.d;
  return (
    <div className="page-section stage-showcase section-buy-now bg-grey">
      <div className="stage-sc-title">
        <h2>X系列</h2>
        <div className="buy-more-link">
          <a
            className="line-link"
            href="https://www.vivo.com.cn/vivo/product/contrast?code=x60tproplus"
            data-track='{"type":"click","params":{"pageview":"官网系列详情页","cfrom":"2208","name":"X60t Pro+","series":"X系列","position":"31","pointsname":"机型对比"}}'
          >
            机型对比
          </a>
        </div>
      </div>
      <div className="stage-sc-figure">
        <div className="stage-sc-row">
          <div className="stage-sc-col stage-sc-left">
            <div className="figure SC-phone-a lazyBackground" style={{ backgroundImage: `url(${x60ProImg})` }} />
            <p>X60t Pro+</p>
            <a
              className="line-link"
              id="buy-link1"
              href="https://shop.vivo.com.cn/product/10006689"
              data-track='{"type":"click","params":{"pageview":"官网系列详情页","cfrom":"2208","name":"X60t Pro+","series":"X系列","position":"31","pointsname":"机型对比立即购买X60 Pro+"}}'
            >
              立即购买
            </a>
          </div>
          <div className="stage-sc-col stage-sc-right">
            <div className="figure SC-phone-b lazyBackground" style={{ backgroundImage: `url(${x60Img})` }} />
            <p>X60 Pro+</p>
            <a
              className="line-link"
              id="buy-link2"
              href="https://shop.vivo.com.cn/product/10006210"
              data-track='{"type":"click","params":{"pageview":"官网系列详情页","cfrom":"2208","name":"X60 Pro+","series":"X系列","position":"31","pointsname":"机型对比立即购买X60 Pro"}}'
            >
              立即购买
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
